var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 7.5C0.666992 6.32149 0.666992 5.73223 1.03311 5.36612C1.39923 5 1.98848 5 3.16699 5H8.83366C10.0122 5 10.6014 5 10.9675 5.36612C11.3337 5.73223 11.3337 6.32149 11.3337 7.5V9.25C11.3337 11.0178 11.3337 11.9017 10.7845 12.4508C10.2353 13 9.35143 13 7.58366 13H4.417C2.64923 13 1.76534 13 1.21617 12.4508C0.666992 11.9017 0.666992 11.0178 0.666992 9.25V7.5Z",
    stroke: "#81807F",
    strokeWidth: 1.14474
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 4.33333V3.66667C8.66683 2.19391 7.47292 1 6.00016 1V1C4.5274 1 3.3335 2.19391 3.3335 3.66667V4.33333",
    stroke: "#81807F",
    strokeWidth: 1.14474,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.00033,
    cy: 8.99935,
    r: 1.33333,
    fill: "#81807F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.32534b790f91ca10f426dc70ae5ddaec.svg";
export { ForwardRef as ReactComponent };